var _defs, _line, _path, _line2, _path2, _path3, _path4, _g, _path5, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-car",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .icon-line--style {\n        fill: none;\n        stroke: #000;\n        stroke-width: 4px;\n        stroke-linejoin: round;\n      }\n\n      .icon-line--miter-limit {\n        stroke-miterlimit: 10;\n      }\n\n      .icon-line--linecap {\n        stroke-linecap: round;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--miter-limit",
    x1: 76.91,
    y1: 86.8,
    x2: 46.78,
    y2: 86.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-line--style icon-line--miter-limit",
    d: "M97.3,76.65h17.63A5.07,5.07,0,0,1,120,81.72h0a5.07,5.07,0,0,1-5.07,5.07H100.8"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--miter-limit",
    x1: 43.17,
    y1: 76.65,
    x2: 80.51,
    y2: 76.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-line--style icon-line--miter-limit",
    d: "M22.78,86.8H13.07A5.07,5.07,0,0,1,8,81.73H8a5.07,5.07,0,0,1,5.07-5.07H26.38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon-line--style icon-line--miter-limit",
    d: "M12,76.65v-14a8,8,0,0,1,8-8h88a8,8,0,0,1,8,8v14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "icon-line--style",
    d: "M108,62h8a0,0,0,0,1,0,0v8a0,0,0,0,1,0,0h-8a4,4,0,0,1-4-4v0a4,4,0,0,1,4-4Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "icon-line--style icon-line--miter-limit",
    cx: 88.91,
    cy: 85.22,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "icon-line--style icon-line--miter-limit",
    cx: 88.91,
    cy: 85.22,
    r: 4
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "icon-line--style icon-line--miter-limit",
    d: "M52.51,35.31H67.2A16,16,0,0,1,80,41.64l9.86,13H24.12s2.13-19.34,14.66-19.34H52.51v19"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "icon-line--style icon-line--miter-limit",
    cx: 34.78,
    cy: 85.22,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "icon-line--style icon-line--miter-limit",
    cx: 34.78,
    cy: 85.22,
    r: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCar);
export default __webpack_public_path__ + "static/media/icon-car.6f88de8c.svg";
export { ForwardRef as ReactComponent };